var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAquarius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.588 14.377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.353,453.742c-.678-1.086-1.312-2.207-1.955-3.321,4.77-3.5,9.423-7.136,14.255-10.583,1.571,2.677,3.027,5.47,4.67,8.081,3.561-2.445,6.938-5.08,10.542-7.477,1.467,2.541,2.957,5.07,4.367,7.675,3.981-2.661,7.711-5.58,11.646-8.279,2.161,3.921,4.427,7.754,6.574,11.688-1.09.77-2.085,1.635-3.263,2.317-1.551-2.785-3.143-5.518-4.72-8.283-3.905,2.711-7.663,5.584-11.594,8.283-1.419-2.621-2.911-5.162-4.364-7.731-3.609,2.427-7.026,5.058-10.6,7.533-1.477-2.753-3.057-5.38-4.57-8.085q-5.543,4.019-10.942,8.183Z",
    transform: "translate(-321.392 -439.837)",
    fill: "#1a1818",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.459,460c-1.086.8-2.153,1.6-3.267,2.359q-2.371-4.126-4.714-8.285c-4,2.637-7.651,5.6-11.648,8.227-1.44-2.6-2.887-5.212-4.424-7.725-3.515,2.513-6.958,5.094-10.54,7.526-1.5-2.727-3.013-5.446-4.616-8.075-3.657,2.729-7.253,5.528-10.992,8.175-.578-1.122-1.284-2.129-1.865-3.261,4.65-3.607,9.463-7.034,14.111-10.641h.1c1.543,2.713,3.093,5.408,4.62,8.131,3.6-2.443,7.013-5.072,10.594-7.53,1.535,2.519,2.9,5.2,4.468,7.685,3.879-2.713,7.7-5.486,11.5-8.285h.05c.652,1.092,1.232,2.251,1.909,3.311v.052c1.524,2.815,3.117,5.55,4.722,8.291Z",
    transform: "translate(-321.395 -431.364)",
    fill: "#1a1818",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquarius);
export default __webpack_public_path__ + "static/media/Aquarius.b895f413b7fa02ecaf35c51b1d244768.svg";
export { ForwardRef as ReactComponent };